import React from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
//import { format, startOfMonth } from 'date-fns';
import { RootState } from "../services/rootReducer";
import { Container, Button, ButtonToolbar } from 'react-bootstrap';
import ListIcon from "@material-ui/icons/List";
import DateRangeIcon from "@material-ui/icons/DateRange";
import ReactTooltip from "react-tooltip";
import CONSTANTS from "../constants";
import { setType, viewType as vt, calRangeType, cursorsType, setCalRangeUsed, setCursors, switchToCalendarView, selectViewType, selectPageRange } from "../services/View_Slice"
import styles from "./css/ViewSwitch.module.css";

function ViewSwitch() {
    const dispatch = useDispatch();

    const viewType = useSelector(selectViewType);
    const mobile = useSelector((state: RootState) => state.View.mobile);
    const freeTextSearch = useSelector((state: RootState) => state.Search.freeTextSearch);
    const result = useSelector((state: RootState) => state.Query.result);
    const pageRangeUsed = useSelector(selectPageRange);

    //
    const usedGlIconStyle = mobile ? styles.glIcon_mobile: styles.glIcon;

    // Disable calendar view when showing search results
    const hasSearchResults = result && result.numFound !== undefined;
    const isCalendarDisabled = !!(hasSearchResults && freeTextSearch && freeTextSearch.length > 0);

    const listDisabled = viewType===0 ? true : false;
    const listOutline = listDisabled ? "light" : "outline-secondary";
    const calDisabled = (viewType===0 ? false : true) || isCalendarDisabled;
    const calOutline = calDisabled ? "light" : "outline-secondary";

    // the tooltip remain when cal/list is changed: use a timeout to hide it after delay
    var ideTooltipFunction = (inst?: any) => {
        //console.log("@@@@ ViewSwitch WILL HIDE TOOLTIP:" + inst);
        ReactTooltip.hide();
    };

    const listTooltip = <ReactTooltip className={styles.glToolTip} id={"tipList"} place="top" effect="solid" textColor='#000000' backgroundColor={CONSTANTS.UI.TOOLTIP_COLOR} afterShow={() => { setTimeout(() => ideTooltipFunction(), 2000) } }>
        Switch to list view
    </ReactTooltip>

    const calTooltip  = <ReactTooltip className={styles.glToolTip} id={"tipCal"} place="top" effect="solid" textColor='#000000' backgroundColor={CONSTANTS.UI.TOOLTIP_COLOR} afterShow={() => { setTimeout(() => ideTooltipFunction(), 2000) } }>
        {isCalendarDisabled ? 'In search mode this function is disabled. Remove the searched keyword to see the calendar view' : 'Switch to calendar view'}
    </ReactTooltip>

    return(
        <Container className={styles.container}>
            <ButtonToolbar>
            <Button size="sm"
                    value="List"
                    onClick={(e) => {
                        //const aa = listTooltip as ReactTooltip;
                        // change view type
                        // reset cursor start, rows, etc
                        const cursorInfo: cursorsType = {
                            cursorStart: 0,
                            cursorRows: pageRangeUsed,
                        }
                        // update store
                        dispatch(setCursors(cursorInfo));
                        // dispatch(setCalRangeUsed(calRangeType.month));
                        //dispatch(setCalRangeValue(dateMonth));
                        dispatch(setType(vt.List));
                    }}
                    disabled={listDisabled}
                    data-for={"tipList"}
                    data-tip
                    >
                <ListIcon className={usedGlIconStyle}/>
            </Button>
            {/*<ReactTooltip id={"tipList"} place="top" effect="solid" textColor='#000000'backgroundColor='#ffb388'>
                Switch to list view
                </ReactTooltip>*/}
            {listTooltip}
            <Button size="sm"
                    value="Calendar"

                    onClick={(e) => {
                        // change view type
                        // reset cursor start, rows, etc
                        const cursorInfo: cursorsType = {
                            cursorStart: 0,
                            cursorRows: pageRangeUsed,
                        }
                        // update store
                        dispatch(setCursors(cursorInfo));
                        // dispatch(setCalRangeUsed(calRangeType.month));
                        //dispatch(setCalRangeValue(dateMonth));
                        // Use switchToCalendarView thunk to automatically navigate to latest search result
                        dispatch(switchToCalendarView());
                    }}
                    disabled={calDisabled}
                    data-for={"tipCal"}
                    data-tip
                    >
                <DateRangeIcon className={usedGlIconStyle}/>
            </Button>
            {/*<ReactTooltip id={"tipCal"} place="top" effect="solid" textColor='#000000'backgroundColor='#ffb388'>
                Switch to calendar view
                </ReactTooltip>*/}
            {calTooltip}
            </ButtonToolbar>
        </Container>
    )
}

export default React.memo(ViewSwitch);
